import Immutable from 'immutable';
import { SET_TTFF_START } from '../actions/videoPlayer';

const VIDEO_PLAYER = 'videoPlayer';
const TTFF_START = 'TTFFStart';

const initialState = Immutable.Map({
    [VIDEO_PLAYER]: { [TTFF_START]: null },
});

export default function videoPlayer(state = initialState, action) {
    switch (action.type) {
        case SET_TTFF_START:
            return state.setIn([TTFF_START], action.payload);
        default:
            return state;
    }
}
export const getTTFFStartTime = (state) => {
    return state.getIn([VIDEO_PLAYER, TTFF_START], null);
};
